import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useAuth } from '../../AuthContext';
import {
  Toolbar, IconButton, TextField, Box, Menu, MenuItem, Avatar,
  Typography, Tooltip, Button, useMediaQuery
} from '@mui/material';

import {
  Logout as LogoutIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  CreditCard as CreditCardIcon,
  Description as DescriptionIcon,
  Dashboard,
  DangerousRounded,
} from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReplayIcon from '@mui/icons-material/Replay';
import { useTheme } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ExpertOnboarding from '../Expert/ExpertOnboarding';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SchoolIcon from '@mui/icons-material/School';
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";

import Logo1 from '../Logo/Dark/Icon - Copy/1Asset 15@72x-8.png';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';

const API_URL = process.env.REACT_APP_API_URL;

function Header1({ onLogout, page_name, onSearch }) {
  const { userId } = useAuth();
  const { role, roles } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { loggedIn } = useAuth();
  const { logout } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [userData, setUserData] = useState({ name: '', surname: '', image: '', role: '', });
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isSearchActive, setIsSearchActive] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  

  const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role]; // Unified role list

  const allowedPages = ['posted', 'category', 'recent-activity', 'posts', 'bookings', 'request_topic', 'request_user', 'recommended_organizations_list','about-us'];

  useEffect(() => {
    if (!userId) return;

    axios.get(`${API_URL}/get_user_data/?user_id=${userId}`)
      .then((res) => setUserData(res.data))
      .catch(console.error);

    // axios.post(`${API_URL}/api/check-verification/`, { user_id: userId })
    //   .then((res) => setIsVerified(res.data.status === 'approved'))
    //   .catch(() => setIsVerified(false))
    //   .finally(() => setLoading(false));
  }, [userId]);

  // useEffect(() => {
  //   if (role === 'expert' || role === 'admin') {
  //     setIsVerified(true);
  //   }
  // }, [role]);

  useEffect(() => {
  if (userRoles.includes('expert') || userRoles.includes('admin')) {
    setIsVerified(true);
  }
}, [userRoles]);

const handleLoginClick = () => {
    navigate("/login", {
      state: { from: location.pathname },
    });
  };


  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const effectiveUserId = loggedIn ? userId : 'f8b1c85b-90e2-4e24-8e41-4c2896990b10';
      fetch(`${API_URL}/get_search_results/?page_name=${page_name}&search_input=${searchQuery}&user_id=${effectiveUserId}`)
        .then(res => res.json())
        .then(data => {
          onSearch(data);
          setSearchQuery('');
          setIsSearchActive(false);
        })
        .catch(console.error);
    }
  };

  const handleClear = () => setSearchQuery('');
  const handleLogout = () => {
    logout();
    // navigate('/login');
    navigate("/login", {
      state: { from: location.pathname },
    });
  };

  return (
    <>
      {/* Header Container using Box */}
      <Box
        sx={{
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 1100,
          bgcolor: '#000000',
          color: 'white',
          px: 2,
          // py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: isMobile ? '1px solid #333' : 'none',
          // borderBottom: '1px solid #333',
        }}
      >
        {/* Logo Section */}
        <Tooltip title="Home" placement="bottom">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/home" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src={isMobile ? Logo1 : Logo} alt="Logo" style={{ width: isMobile ? '40px' : '120px' }} />
          </Link>
        </Box>
        </Tooltip>

        {/* Search Bar - only on allowed pages and non-mobile */}
        {allowedPages.includes(page_name) && !isMobile && (
          <Box
            component="form"
            onSubmit={handleSearchSubmit}
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              maxWidth: 600,
              bgcolor: '#000000',
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              mx: 2,
              flexGrow: 1,
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {searchQuery && (
                      <Tooltip title="Clear">
                        <IconButton onClick={handleClear} size="small" sx={{ color: 'white' }}>
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Search">
                      <IconButton type="submit" size="small" sx={{ color: 'white' }}>
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                ),
                sx: {
                  input: { color: 'white' },
                  backgroundColor: '#1c1c1c',
                  borderRadius: 2,
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#444' },
                },
              }}
            />
          </Box>
        )}

        {/* Actions Section */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {allowedPages.includes(page_name) && isMobile && (
            <Tooltip title="Search">
              <IconButton onClick={() => setIsSearchActive(true)} sx={{ color: 'white' }}>
                <SearchIcon />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Platform" placement="bottom">
            <IconButton component={Link} to="/chatbot" color="inherit">
          
              <Typography
                component="h1"
                sx={{
                  backgroundImage: "linear-gradient(45deg, #00bfff, #ff00ff)",
                  backgroundClip: "text",
                  color: "transparent",
                  letterSpacing: 4,
                  fontSize: { xs: '0.7rem', sm: '1rem' },
                }}
              >
                Vimitra
              </Typography>
              <Box
                sx={{
                  ml: 1,
                  px: 0.5,
                  py: 0.1,
                  bgcolor: '#1E90FF',
                  borderRadius: '4px',
                  color: 'white',
                  fontSize: { xs: '0.55rem', sm: '0.7rem' },
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
              >
                Beta
              </Box>
            </IconButton>
          </Tooltip>
          {loggedIn ? (
            <>


              <Tooltip title="Profile">
                <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ color: 'white' }}>
                  {/* <Avatar sx={{ bgcolor: '#444' }}>
                    {(userData.name?.[0] || '') + (userData.surname?.[0] || '')}
                  </Avatar> */}
                  <Avatar
                                        sx={{ width: 40, height: 40, bgcolor: '#0e4686ff', fontSize: 28 }}
                                        src={userData.image || undefined}
                                      >
                                        {!userData.image && userData.name
                                          ? userData.name.charAt(0).toUpperCase()
                                          : null}
                                      </Avatar>
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Button
        variant="outlined"
        size="small"
        onClick={handleLoginClick}
        sx={{
          mt: 0.5,
          mb: 0.5,
          letterSpacing: 2,
          transition: "transform 0.2s ease",
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      >
        Login
      </Button>
    </Box>
          )}

        </Box>
      </Box>

      {/* Spacer for fixed header */}
      <Box sx={{ height: '64px' }} />

      {/* Mobile Fullscreen Search */}
      {allowedPages.includes(page_name) && isMobile && isSearchActive && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(0,0,0,0.95)',
            zIndex: 1300,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: 2,
          }}
        >
          <TextField
            autoFocus
            fullWidth
            variant="outlined"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit(e)}
            InputProps={{
              endAdornment: (
                <IconButton onClick={handleSearchSubmit} color="primary">
                  <SearchIcon />
                </IconButton>
              ),
              sx: {
                backgroundColor: 'white',
                borderRadius: 2,
              },
            }}
          />
          <Button onClick={() => setIsSearchActive(false)} sx={{ mt: 2, color: 'white' }}>
            Cancel
          </Button>
        </Box>
      )}

      {/* Profile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            bgcolor: 'black',
            color: 'white',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
          },
        }}
      >
        <MenuItem component={Link} to={`/UserProfile`} onClick={() => setAnchorEl(null)}>
          <PersonIcon fontSize="small" sx={{ mr: 1 }} /> User Portal
        </MenuItem>
        {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
  <MenuItem component={Link} to="/admin-panel" onClick={() => setAnchorEl(null)}>
    <PersonIcon fontSize="small" sx={{ mr: 1 }} /> Admin Panel
  </MenuItem>
)}
{['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
  <MenuItem component={Link} to="/admin-control-center" onClick={() => setAnchorEl(null)}>
    <PersonIcon fontSize="small" sx={{ mr: 1, color: "#ff7300ff" }} />
 Admin Control Center
  </MenuItem>
)}

{/* {['sales-executive', 'anthra-sales-executive', 'admin', 'ambassador', 'sales-partner-individual', 'sales-partner-company'].some(r => userRoles.includes(r)) && (
  <MenuItem component={Link} to="/dashboard" onClick={() => setAnchorEl(null)}>
    <Dashboard fontSize="small" sx={{ mr: 1 }} /> Dashboard
  </MenuItem>
)} */}
{[ 'anthra-sales-executive', 'admin'].some(r => userRoles.includes(r)) && (
  <MenuItem component={Link} to="/dashboard" onClick={() => setAnchorEl(null)}>
    <Dashboard fontSize="small" sx={{ mr: 1 }} /> Dashboard
  </MenuItem>
)}
 {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
  <MenuItem component={Link} to="/ambassador-onboarding" onClick={() => setAnchorEl(null)}>
    <Dashboard fontSize="small" sx={{ mr: 1 }} />  Ambassador Space
  </MenuItem>
)}
{['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
  <MenuItem component={Link} to="/sales-partner-onboarding" onClick={() => setAnchorEl(null)}>
    <Dashboard fontSize="small" sx={{ mr: 1 }} /> Sales Partner Space
  </MenuItem>
)}

        {/* {['admin', 'anthra-sales-executive'].includes(userData.role) && (
          <MenuItem component={Link} to="/admin-panel" onClick={() => setAnchorEl(null)}>
            <PersonIcon fontSize="small" sx={{ mr: 1 }} /> Admin Panel
          </MenuItem>
        )}
        {['sales-executive', 'anthra-sales-executive', 'admin','ambassador','sales-partner-individual','sales-partner-company'].includes(userData.role) && (
          <MenuItem component={Link} to="/dashboard" onClick={() => setAnchorEl(null)}>
            <Dashboard fontSize="small" sx={{ mr: 1 }} /> Dashboard
          </MenuItem>
        )} */}
        {/* <MenuItem component={Link} to="/Documentation" onClick={() => setAnchorEl(null)}>
          <DescriptionIcon fontSize="small" sx={{ mr: 1 }} /> Documentation
        </MenuItem> */}
        
        <MenuItem component={Link} to="/subscription-page" onClick={() => setAnchorEl(null)}>
          <SubscriptionsIcon fontSize="small" sx={{ mr: 1 }} /> Subscriptions
        </MenuItem>
        <MenuItem component={Link} to="/transactions" onClick={() => setAnchorEl(null)}>
          <ReceiptIcon fontSize="small" sx={{ mr: 1 }} /> Transactions
        </MenuItem>
        <MenuItem component={Link} to="/expert-onboarding" onClick={() => setAnchorEl(null)}>
          <WorkspacePremiumIcon fontSize="small" sx={{ mr: 1 }} />
          Expert Space
        </MenuItem>
       
        {/* <MenuItem component={Link} to="/ambassador-onboarding" onClick={() => setAnchorEl(null)}>
          <EmojiEventsIcon fontSize="small" sx={{ mr: 1 }} />
          Ambassador Space
        </MenuItem> */}

 

         {/* <MenuItem component={Link} to="/sales-partner-onboarding" onClick={() => setAnchorEl(null)}>
           <HandshakeIcon fontSize="small" sx={{ mr: 1 }} />
           Sales Partner Space
         </MenuItem> */}
        {/* <MenuItem component={Link} to="/ai-program-page" onClick={() => setAnchorEl(null)}>
          <SchoolIcon fontSize="small" sx={{ mr: 1 }} />
          AI Training Program
        </MenuItem> */}




        {isVerified && (
          <MenuItem component={Link} to="/expert-payment-details" onClick={() => setAnchorEl(null)}>
            <PaymentsIcon fontSize="small" sx={{ mr: 1 }} /> Payments
          </MenuItem>
        )}
        {/* <MenuItem component={Link} to="/user-refunds" onClick={() => setAnchorEl(null)}>
            <ReplayIcon fontSize="small" sx={{ mr: 1 }} /> Refunds
          </MenuItem> */}

        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            handleLogout();
          }}
        >
          <LogoutIcon fontSize="small" sx={{ mr: 1 }} /> Logout
        </MenuItem>
      </Menu>
    </>
  );
}

export default Header1;
